import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Title} from "@angular/platform-browser";
import {ReviewService} from "../review.service";

@Component({
  selector: 'app-otzyvy',
  templateUrl: './otzyvy.component.html',
  styleUrls: ['./otzyvy.component.scss']
})
export class OtzyvyComponent implements OnInit {
  reviews;
  currPage = 1;
  pagesCount = 3;
  currCategory =null;
  showAllOptions = false;
  filters = [
    {
      label: "Сначала новые",
      selected: true,
      param: ''
    },
    {
      label: "Сначала старые",
      selected: false,
      param: {ordering: 'date_review'}
    },
    {
      label: "За текущий год",
      selected: false,
      param: {year: '2025'}
    },
    {
      label: "За прошлый год",
      selected: false,
      param: {year: '2024'}
    }
  ];

  @ViewChild('rubricator', {static: false}) rubricator: ElementRef;
  categories = [{label:'Все отзывы', active: true},
    {label: '', active: false},
    {label: 'Лицензирование', active: false},
    {label: '', active: false},
    {label:'Разрешение на применение', active: false},
    {label:'Аттестация и аккредитация лабораторий', active: false},
    {label:'ЭПБ, ТО и ТД', active: false},
    {label:'Сертификация оборудования', active: false},
    {label:'Аттестация специалистов', active: false},
      {label:'Нормативная документация ОПО', active: false},
    {label: '', active: false},
    {label: '', active: false},
    {label:'Консервация, ликвидация и техническое перевооружение', active: false}]

  constructor( private titleService: Title, private reviewService: ReviewService) { }

  ngOnInit(): void {
    this.reviewService.getAll().subscribe((res:any) => {
      this.reviews = res.results;
      this.pagesCount = Math.floor(res.count / 20)+1;
    })

  }

  getSelectedFilter(){
    return this.filters.find(el => el.selected === true);
  }
  getUnselectedFilters(){
    return this.filters.filter(el=> el.selected === false);
  }
  setSelected(label: string){
    this.filters.forEach(el => {
      if(el.label === label) el.selected = true;
      else el.selected = false;
    })
  }
  refreshData(){
    console.log(this.currCategory);
    if(this.currCategory === null||this.currCategory ===0){
      console.log(this.getSelectedFilter());
      this.reviewService.getAll(Object.assign({page: this.currPage}, this.getSelectedFilter().param )).subscribe((res:any) => {
        this.reviews = res.results;
        this.pagesCount = Math.floor(res.count / 20)+1;
      })
    } else {
      console.log(this.getSelectedFilter().param);
      this.reviewService.getAll(Object.assign({
        page: this.currPage,
        category: this.currCategory
      }, this.getSelectedFilter().param)).subscribe((res: any) => {
        this.reviews = res.results;
        this.pagesCount = Math.floor(res.count / 20) + 1;
      })
    }
  }
  createRange(number){
    return new Array(number);
  }




  setActive(i){
    this.currCategory = i;
    for(let el of this.categories){
      if(this.categories.indexOf(el) === i) {
        this.categories[this.categories.indexOf(el)].active = true;
        this.refreshData();
      }
      else
        this.categories[this.categories.indexOf(el)].active = false;
    }
  }

}
